var _path, _path2, _circle, _path3, _path4, _polygon, _path5, _path6, _path7, _polygon2, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMailopenIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 522.70767,
    height: 519.89075,
    viewBox: "0 0 522.70767 519.89075",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M686.31988,709.94537H367.17724a28.56333,28.56333,0,0,1-28.53107-28.53107V218.5857a28.56333,28.56333,0,0,1,28.53107-28.53107H686.31988A28.56334,28.56334,0,0,1,714.851,218.5857V681.4143A28.56334,28.56334,0,0,1,686.31988,709.94537Z",
    transform: "translate(-338.64617 -190.05463)",
    fill: "#3f3d56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M686.88163,691.74192H366.61549a8.80508,8.80508,0,0,1-8.795-8.795V217.0531a8.80508,8.80508,0,0,1,8.795-8.795H686.88163a8.80508,8.80508,0,0,1,8.795,8.795V682.9469A8.80508,8.80508,0,0,1,686.88163,691.74192Z",
    transform: "translate(-338.64617 -190.05463)",
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 186.88883,
    cy: 8.73766,
    r: 2.42713,
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M612.177,405.28716l-10.6024-31.754-.17933-.55212,44.649-28.203,2.37364,3.19859,12.43482,16.74467-4.54531,13.54319-11.74842,34.9907-.515,1.53794,21.757,16.176c.86226,1.59041,1.57853,3.04024,2.161,4.37279,6.4953,14.80006-3.11917,14.12857-3.11917,14.12857l-44.24883-18.96666Z",
    transform: "translate(-338.64617 -190.05463)",
    fill: "#ffb7b7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M635.60179,411.19848l-1.95073-5.8455-9.57345-28.69551-1.9943-5.98167-1.675-5.00588,21.83164-13.79431,22.81745-14.4087,14.80845,19.94323-4.48818,13.37234-2.18155,6.49743L669.82365,387.33l-6.76651,20.15194,21.75695,16.176a42.20643,42.20643,0,0,1,3.87179,9.14952,14.06581,14.06581,0,0,1,.53247,4.09689,5.01666,5.01666,0,0,1-5.36243,5.255L639.6071,423.19266Z",
    transform: "translate(-338.64617 -190.05463)",
    fill: "#ffb7b7"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "294.88 222.439 292.312 195.37 305.108 188.432 305.945 189.977 294.17 196.361 296.551 221.455 322.712 239.371 321.72 240.82 294.88 222.439",
    opacity: 0.15,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 673.23757,
    y: 405.63369,
    width: 1.75645,
    height: 32.8255,
    transform: "translate(-404.56668 523.37055) rotate(-53.54095)",
    opacity: 0.15,
    style: {
      isolation: "isolate"
    }
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "321.218 248.065 188.403 154.698 54.232 247.195 186.402 303.007 321.218 248.065",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M564.774,358.87005l44.72349-43.72779,79.98666-5.404,99.42707,94.94445,72.44264,39.64481L840.94528,504.343,753.5081,462.83763c-17.80159-1.30756-29.25633-7.215-36.50041-13.42737a44.09751,44.09751,0,0,1-6.69437-7.16968,32.23633,32.23633,0,0,1-4.95146-9.24345L669.82367,387.33l-7.32688-9.42411-4.7454-6.09854L642.2399,351.87566l-1.11627-1.43272-26.35216-.69776-13.71473,18.005-9.63308,12.63516a21.41738,21.41738,0,0,1-4.59739,12.21273c-8.63871,10.50776-26.15458,8.45585-26.15458,8.45585Z",
    transform: "translate(-338.64617 -190.05463)",
    fill: "#ffb7b7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M393.39006,437.164h.09566l54.85333,23.4226,75.05068,32.04721a2.42068,2.42068,0,0,0,1.85411.00955l77.4302-32.12366L658.875,437.20221l.08586-.03822h.09566a3.34843,3.34843,0,0,1,3.34472,3.34472V585.76517a3.34844,3.34844,0,0,1-3.34472,3.34472H393.39006a3.34844,3.34844,0,0,1-3.34472-3.34472V440.50871A3.34843,3.34843,0,0,1,393.39006,437.164Z",
    transform: "translate(-338.64617 -190.05463)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M393.15159,438.11962a.47629.47629,0,0,0,.27274-.08562L525.569,346.00471a2.39647,2.39647,0,0,1,2.73718.00466l131.19272,92.0237a.47791.47791,0,0,0,.54886-.78252L528.85488,345.22686a3.3553,3.3553,0,0,0-3.8321-.0063l-132.1446,92.029a.47791.47791,0,0,0,.27344.87Z",
    transform: "translate(-338.64617 -190.05463)",
    fill: "#3f3d56"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "313.356 251.327 188.162 158.543 62.019 257.929 181.712 328.885 246.695 314.073 313.356 251.327",
    fill: "#e6e6e6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M579.8557,562.766h61.84883a2.88954,2.88954,0,0,0,.00854-5.77907H579.8557a2.88954,2.88954,0,0,0-.00855,5.77907Z",
    transform: "translate(-338.64617 -190.05463)",
    fill: "#6c63ff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M619.51455,550.34279h22.19a2.88954,2.88954,0,0,0,.00854-5.77907H619.51455a2.88954,2.88954,0,0,0-.00855,5.77907Z",
    transform: "translate(-338.64617 -190.05463)",
    fill: "#6c63ff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M525.04786,493.06129a3.61381,3.61381,0,0,0,1.37092-.26854l77.21089-32.03709V360.47424a3.34863,3.34863,0,0,0-3.34472-3.34472H452.16159a3.34863,3.34863,0,0,0-3.34472,3.34472V460.82566l.14512.06206,74.67342,31.88939A3.63912,3.63912,0,0,0,525.04786,493.06129Z",
    transform: "translate(-338.64617 -190.05463)",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M523.54162,492.99665,448.578,460.98337V360.47422a3.5877,3.5877,0,0,1,3.58363-3.58363H600.285a3.58769,3.58769,0,0,1,3.58363,3.58363v100.441l-77.3588,32.0987a3.8853,3.8853,0,0,1-2.96816-.01728ZM602.913,360.47422a2.63112,2.63112,0,0,0-2.628-2.628H452.16159a2.63111,2.63111,0,0,0-2.628,2.628V460.3525l74.38131,31.76459a2.92338,2.92338,0,0,0,2.23047.0133l76.7676-31.85348Z",
    transform: "translate(-338.64617 -190.05463)",
    fill: "#3f3d56"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M390.76216,440.50871V585.76517a3.34844,3.34844,0,0,0,3.34472,3.34472H659.77329a3.34843,3.34843,0,0,0,3.34472-3.34472V440.50871a3.34842,3.34842,0,0,0-3.34472-3.34472h-.09565l-.08586.03822-56.20093,23.31748-77.4302,32.12366a2.42068,2.42068,0,0,1-1.85411-.00955l-75.05067-32.04721L394.20253,437.164h-.09565A3.34843,3.34843,0,0,0,390.76216,440.50871Zm.95563,0a2.39683,2.39683,0,0,1,2.29343-2.38908l55.04465,23.50383L523.72905,493.513a3.40248,3.40248,0,0,0,2.5993.01434l77.0625-31.97554,56.4732-23.43217a2.39438,2.39438,0,0,1,2.29833,2.38909V585.76517a2.39,2.39,0,0,1-2.38909,2.38908H394.10688a2.39,2.39,0,0,1-2.38909-2.38908Z",
    transform: "translate(-338.64617 -190.05463)",
    fill: "#3f3d56"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M465.12865,394.615h52.5599a3.82254,3.82254,0,0,0,0-7.64508h-52.5599a3.82254,3.82254,0,0,0,0,7.64508Z",
    transform: "translate(-338.64617 -190.05463)",
    fill: "#6c63ff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M465.16017,378.36925h25.32432a3.82254,3.82254,0,0,0,0-7.64508H465.16017a3.82254,3.82254,0,0,0,0,7.64508Z",
    transform: "translate(-338.64617 -190.05463)",
    fill: "#6c63ff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M486.9125,432.84042h80.27331a3.82254,3.82254,0,1,0,0-7.64508H486.9125a3.82254,3.82254,0,0,0,0,7.64508Z",
    transform: "translate(-338.64617 -190.05463)",
    fill: "#ccc"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M486.9125,450.51966h80.27331a3.82254,3.82254,0,0,0,0-7.64508H486.9125a3.82254,3.82254,0,0,0,0,7.64508Z",
    transform: "translate(-338.64617 -190.05463)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M673.196,377.28l15.94362-.92183L752.843,454.86658l-22.50573-3.44243-13.32953-2.01389a44.09751,44.09751,0,0,1-6.69437-7.16968l-14.81145-4.39729-6.816-5.03581C689.1135,434.44384,673.196,377.28,673.196,377.28Z",
    transform: "translate(-338.64617 -190.05463)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M571.28277,374.78155A11.249,11.249,0,0,1,584.061,365.3861L601.05676,367.75l21.02662,2.92572,16.24962,2.25894,19.41836-1.12742,17.62627-1.02486,10.41342-.60085L755.03363,455.517l-59.53175-17.67377-6.816-5.03581-29.8425-22.042s-9.778-1.80157-25.19232-5.41249c-2.29336-.54479-28.241-7.05619-40.43033-10.59741-2.3612-.68783-4.47954-1.40743-6.39447-2.15748C573.23666,387.2487,570.51776,380.39112,571.28277,374.78155Z",
    transform: "translate(-338.64617 -190.05463)",
    fill: "#ffb7b7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M581.01687,385.44227c.06083-.007,6.127-.76264,8.71645-5.20513,1.74447-2.99275,1.569-7.02305-.52118-11.97829l1.61829-.68249c2.31931,5.49829,2.45841,10.05961.41334,13.5571-3.04169,5.20219-9.74316,6.02158-10.02693,6.05408Z",
    transform: "translate(-338.64617 -190.05463)",
    opacity: 0.15,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "303.71 183.525 303.706 181.769 334.938 181.719 302.012 161.133 302.943 159.643 341.046 183.465 303.71 183.525",
    opacity: 0.15,
    style: {
      isolation: "isolate"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailopenIcon);
export default __webpack_public_path__ + "static/media/mailopen-icon.d4d00dad1e4658b073d0fb7e5bc5a71b.svg";
export { ForwardRef as ReactComponent };